import cx from "classnames";
import Link from "next/link";

import { CampaignSlots } from "@/custom-types/Directus";
import { useEventTracker } from "@/hooks/useEventTracker";

import Image from "@/components/Image";
import TrackImpression from "@/components/TrackImpression";

const CampaignCard = ({
  title,
  subtitle,
  cta_for_button,
  link_url,
  image,
  className,
}: Omit<CampaignSlots<string>, "targeting"> & {
  className: string;
}) => {
  const { publishEvent } = useEventTracker();

  return (
    <TrackImpression
      category="Homepage Campaign"
      label={title}
      className={cx("relative", className)}
    >
      <Link
        className="overlay-gradient-black flex items-end rounded overflow-hidden h-full"
        href={link_url || ""}
        style={{ minHeight: 290 }}
        onClick={() => {
          publishEvent({
            action: "Click",
            category: "Homepage Campaign",
            label: title || "",
          });
        }}
      >
        <div className="relative text-white m-xl md:m-xxl z-10">
          <p className="heading--xl mb-lg md:mb-xs">{title}</p>
          <p className="hidden md:block">{subtitle}</p>
          <div className="button inline-block" style={{ minWidth: 160 }}>
            {cta_for_button}
          </div>
        </div>
        {image && (
          <Image
            alt={`${title} image`}
            background={true}
            sizes={[512, 735, 362, 502, null, 767]} // need to edit once this is in directus for situations where only one shows up
            src={image}
          />
        )}
      </Link>
    </TrackImpression>
  );
};

export default CampaignCard;
